<template>
  <div class="app-container">
    <div ref="searchForm">
      <el-card class="mb5">
        <el-form
          ref="form"
          :model="queryForm"
          label-position="top"
          size="small"
          class="searchContainer"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--账单日期  -->
                <el-form-item :label="$t('receivablePayable.BillingDate')">
                  <el-date-picker
                    v-model="queryForm.params.payableTimes"
                    style="width: 100%"
                    range-separator="-"
                    type="daterange"
                    :start-placeholder="$t('operationCenter.startDate')"
                    :end-placeholder="$t('operationCenter.endDate')"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--收款状态-->
                <el-form-item :label="$t('receivablePayable.ReceiptStatus')">
                  <el-select
                    v-model="queryForm.params.receiptStatus"
                    filterable
                    multiple
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    clearable
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in STATUS_OPTIONS"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--应收主体-->
                <el-form-item :label="$t('basicData.businessPrincipal')">
                  <el-select
                    v-model="queryForm.params.providerId"
                    filterable
                    :placeholder="$t('operationCenter.Only10AreDisplayed')"
                    :remote-method="getProviderPage"
                    remote
                    clearable
                    style="width: 100%;"
                    @focus="getProviderPage('')"
                  >
                    <el-option
                      v-for="item in providerList"
                      :key="item.id"
                      :label="item.providerName + '（' + item.code + '）'"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--客户-->
                <el-form-item :label="$t('GlobalSetObj.client')">
                  <!--                  <CustomerSelectCmp style="width: 100%" @change="val => queryForm.params.customerId = val" />-->
                  <QueryCustomerCmp
                    :val="queryForm.params.customerIds"
                    :multiple="true"
                    @change="val => queryForm.params.customerIds = val"
                  />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--账单批次号-->
                <el-form-item :label="$t('receivablePayable.BillingBatchNumber')" label-width="">
                  <template slot="label">
                    <el-select
                      v-model="typeNumber"
                      filterable
                      :placeholder="$t('operationCenter.PleaseSelect')"
                      clearable
                      style="width: 100%;"
                    >
                      <!--收款单号-->
                      <el-option key="0" :label="$t('basicData.ReceiptNumber')" :value="1" />
                      <!--账单批次号-->
                      <el-option key="1" :label="$t('receivablePayable.BillingBatchNumber')" :value="2" />
                    </el-select>
                  </template>
                  <InputTextareaCmp
                    ref="inputTextareaRef"
                    :val="searchNum"
                    :max-length="200"
                    @input="(_, val) => searchNum = val"
                  />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--对账单类型-->
                <el-form-item :label="$t('receivablePayable.statementType')">
                  <el-select
                    v-model="queryForm.params.statementType"
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    clearable
                    size="small"
                    filterable
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in EXPRESS_TYPE"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--生成人-->
                <el-form-item :label="$t('receivablePayable.BuildThePerson')">
                  <QueryUserV2Cmp :val="queryForm.params.createUser" style="width: 100%" @change=" val => queryForm.params.createUser = val" />
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>

        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="searchResources()"
        >
          {{ $t('operationCenter.Procurar') }}
        </el-button>
        <!--重置-->
        <el-button
          icon="el-icon-refresh"
          size="small"
          @click="onReset"
        >{{ $t('basicData.reset') }}
        </el-button>
      </el-card>
    </div>

    <el-card>
      <div class="row mb10">
        <div style="display: flex">
          <!--收款-->
          <el-button
            v-permit:remove="'btn:receivableManagementSite:billCollection:approved'"
            :disabled="!isDisable"
            size="small"
            type="primary"
            @click="operationBtn"
          >{{ $t('receivablePayable.receivables') }}</el-button>
          <!--自定义栏目-->
          <CustomStatusBar
            :columns-data="TABLE_HEADER"
            :params="searchParams"
            :save-params="customParams"
            @updateColumns="updateColumns"
          />
        </div>
        <div>
          <el-button
            v-permit:remove="'btn:receivableManagementSite:billCollection:exportDetail'"
            icon="el-icon-download"
            size="small"
            @click="onExport"
          >{{ $t('basicData.账单导出') }}</el-button>
        </div>
      </div>

      <!--      row-key="id"-->
      <!--      lazy-->
      <!--      :load="loadNode"-->
      <!--      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"-->
      <div class="pending">
        <el-table
          ref="table"
          :key="tableKey"
          :data="tableData"
          border
          class="table-height"
          :height="tableHeightRow.height"
          @header-dragend="headerWidthChange"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <!--收款批次号-->
          <el-table-column
            prop="receiptNumber"
            :label="$t('receivablePayable.ReceiptBatchNumber')"
            width="240"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <span class="batchNumber" @click="showBillBatchNumber(scope.row)">{{ scope.row.receiptNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, ind) in currentColumns"
            :key="ind"
            :prop="item.prop"
            :label="item.label"
            :align="item.align"
            :min-width="item.width"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <div v-if="item.prop === 'receiptBillName'">
                <span v-if="scope.row.isParent === true">{{ scope.row.receiptBillName }}</span>
                <span v-else>{{ scope.row.billName }}</span>
              </div>
              <div v-else-if="item.prop === 'statementType'">
                {{ EXPRESS_TYPE[scope.row.statementType] ? EXPRESS_TYPE[scope.row.statementType].label : '' }}
              </div>
              <div v-else-if="item.prop === 'receiptStatus'">
                <div v-if="scope.row.receiptStatusItem">
                  <el-tag :type="scope.row.receiptStatusItem.type">{{ scope.row.receiptStatusItem.label }}</el-tag>
                </div>
              </div>
              <div v-else-if="item.prop === 'billFee'">
                <span v-if="scope.row.isParent === true">{{ scope.row.billFee }}</span>
                <span v-else>{{ scope.row.totalReceivable }}</span>
              </div>
              <div v-else-if="item.prop === 'remark'">
                <div class="remarkStyle" @click="showImg($event)" v-html="scope.row.remark" />
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <!--操作-->
          <el-table-column
            :label="$t('basicData.operate')"
            align="center"
            width="140"
            fixed="right"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <div v-if="scope.row.receiptStatus === 0">
                <el-button
                  v-permit:remove="'btn:receivableManagementSite:billCollection:recall'"
                  type="danger"
                  size="mini"
                  @click="recall(scope.row)"
                >{{ $t('receivablePayable.withdraw') }}</el-button> <!--撤回-->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页工具 -->
        <div class="pagination">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="queryForm.pageNumber"
            :page-sizes="[10, 20, 50, 100, 500]"
            :page-size.sync="queryForm.pageSize"
            :total="total"
            background
            style="margin: 10px 0"
            @current-change="getExaminePage"
            @size-change="getExaminePage"
          />
        </div>
      </div>
    </el-card>

    <!--  对账批次详情  -->
    <el-drawer
      :title="$t('receivablePayable.paymentBatchDetails') + '-' + batchNumber"
      :append-to-body="true"
      :visible.sync="showDetail"
      direction="ltr"
      custom-class="drawerClass"
      :label="$t('receivablePayable.ReconcileBatchDetails')"
      size="80%"
    >
      <div>
        <BatchNumberDetail
          :key="batchNumber"
          :batch-number="batchNumber"
          :bill-batch-data="billBatchData"
          @closeDetail="closeDetail"
        />
      </div>
    </el-drawer>

    <!--收款-->
    <el-dialog
      :title="$t('basicData.acceptanceCheck')"
      :visible.sync="showCollection"
      :custom-class="'dialogClass'"
      width="70%"
    >
      <CollectionDetail
        :key="collectionKey"
        :recharge-data="selectData"
        :account-option="accountOption"
        @collectionUpdate="collectionUpdate"
      />
    </el-dialog>
    <div class="imgs">
      <el-image-viewer v-if="imageViewerObj.showViewer" :on-close="closeViewer" :url-list="imageViewerObj.imgArr" />
    </div>
  </div>
</template>

<script>
import { apiProviderPage, apiSiteReceiptExport, apiSiteReceiptGetPage } from '@/api/finance/basicData';
import { accountPage } from '@/api/finance/partition';
import { apiSiteBillCancellationOfReceipt } from '@/api/finance/receivables';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { goFinanceExportPage } from '@/utils/goExportList.js';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { STATUS_OPTIONS, TABLE_HEADER } from './utils';
import { EXPRESS_TYPE } from '../aRGenerationNew/utils';
import { cloneDeep } from 'lodash-es';

const PARAM = {
  payableTimes: [], // 账单日期
  receiptStatus: [0], // 收款状态
  providerId: '', // 业务主体
  customerIds: [], // 客户
  receiptNumber: '', // 收款单
  billBatchNumber: '', // 对账批次号
  statementType: '', // 对账单类型
  createUser: '', // 生成人员
  receiptType: 0 // 收款类型 0 核收 1 充值单
};

export default {
  name: 'BillCollection',
  components: {
    QueryUserV2Cmp: () => import('@/views/finance/cmp/Query/QueryUserV2Cmp.vue'),
    BatchNumberDetail: () => import('./cmp/batchNumberDetail'),
    // CustomerSelectCmp: () => import('@/components/CustomerSelectCmp/CustomerSelectCmp.vue'),
    QueryCustomerCmp: () => import('@/views/finance/cmp/Query/QueryCustomerCmp.vue'),
    InputTextareaCmp: () => import('@/views/finance/cmp/Query/InputTextareaCmp.vue'),
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    CollectionDetail: () => import('./cmp/collectionDetail'),
    CustomStatusBar: () => import('@/components/customStatusBar/index.vue')
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      STATUS_OPTIONS,
      TABLE_HEADER,
      EXPRESS_TYPE,
      queryForm: {
        orderDirection: 'DESC',
        pageNumber: 1,
        pageSize: 10,
        params: {
          ...PARAM
        }
      },
      createUser: [],
      showDetail: false,
      tableData: [],
      total: 0,
      tableKey: new Date().getTime(),
      batchNumber: '',
      billBatchData: {},
      providerList: [],
      showReceivableManage: false,
      selectData: [],
      rowSelectFlag: false,
      showCollection: false,
      collectionKey: new Date().getTime(),
      accountOption: [],
      imageViewerObj: {
        imgArr: [],
        showViewer: false
      },
      typeNumber: 1,
      searchNum: '',
      currentColumns: [],
      searchParams: { // 自定义栏目搜索参数
        type: 0,
        menuEnum: 'companyToSiteBillCollection'
      },
      customParams: {
        templateField: '',
        type: 0,
        userId: '',
        templateName: '应收账单核收',
        menuEnum: 'companyToSiteBillCollection'
      }
    };
  },
  computed: {
    // 待核收、部分核收操作
    isDisable() {
      if (this.selectData.length > 0) {
        return this.selectData.every(item => [0, 2].includes(item.receiptStatus));
      }
      return false;
    }
  },
  created() {
    this.createUser = getUserIdAndNameObj();
    this.getExaminePage();
    this.getAccountOption();
  },
  mounted() {
    this.bus.$on('pendingData', () => {
      this.getExaminePage();
    });
  },
  methods: {
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.currentColumns = cloneDeep(list);
        this.tableKey = new Date().getTime();
      });

      // console.log(list, '列表呈现的columns');
    },

    // 图片点击放大
    showImg(e) {
      if (e.target.tagName === 'IMG') {
        const src = e.target.src;
        if (this.isValidImageUrl(src)) {
          this.$set(this.imageViewerObj, 'showViewer', true);
          this.$set(this.imageViewerObj, 'imgArr', [src]);
        }
      }
    },
    isValidImageUrl(url) {
      const whitelist = ['http://', 'https://'];
      return whitelist.some(protocol => url.startsWith(protocol));
    },
    // 关闭查看图片
    closeViewer() {
      this.$set(this.imageViewerObj, 'showViewer', false);
    },
    // 收款成功刷新列表
    collectionUpdate(type) {
      if (type === 2) {
        this.getExaminePage();
      }
      this.showCollection = false;
    },
    // 撤回
    recall(data) {
      const param = {
        receiptNumbers: [data.receiptNumber]
      };
      this.$confirm(this.$t('receivablePayable.AreYouSureYouWantToWithdraw'), this.$t('basicData.tips'), { // '确定要撤回?'
        confirmButtonText: this.$t('basicData.determine'), // '确定',
        cancelButtonText: this.$t('basicData.Cancel'), // '取消',
        type: 'warning'
      }).then(() => {
        apiSiteBillCancellationOfReceipt(param).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
            this.getExaminePage();
          }
        });
      });
    },
    // 表头宽度变化
    headerWidthChange() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    // 关闭详情
    closeDetail() {
      this.showDetail = false;
    },
    // 获取账户
    getAccountOption() {
      const param = {
        orderDirection: 'DESC',
        pageNumber: 1,
        pageSize: 1000000,
        params: {
          status: 1
        }
      };
      accountPage(param, false).then(res => {
        if (res.code === 200) {
          this.accountOption = res.data.records;
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 获取业务主体
    getProviderPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          providerName: name
        }
      };
      apiProviderPage(param, false).then(res => {
        if (res.code === 200) {
          this.providerList = res.data.records;
        }
      });
    },
    // 查询参数
    getQueryData() {
      // const { pageNumber, pageSize, params: { providerId, receiptStatus, customerIds, payableTimes, createUser, statementType }} = this.queryForm;
      //
      // const param = {
      //   orderDirection: 'DESC',
      //   pageNumber,
      //   pageSize,
      //   params: {
      //     payableTimes, // 账单日期
      //     receiptStatus, // 收款状态
      //     providerId, // 业务主体
      //     customerIds, // 客户
      //     receiptNumbers: [], // 收款单号
      //     billBatchNumbers: [], // 对账单批次号
      //     statementType, // 对账单类型
      //     createUser, // 生成人
      //     receiptType: 0 // 收款类型 0 核收 1 充值单
      //   }
      // };
      const queryParams = cloneDeep(this.queryForm);

      // 收款单号 / 账单批次号
      if (this.searchNum.length >= 1) {
        const val = this.$refs.inputTextareaRef.getValue();
        if (this.typeNumber === 1) {
          queryParams.params.receiptNumbers = val;
        } else {
          queryParams.params.billBatchNumbers = val;
        }
      }

      return queryParams;
    },

    // 获取列表数据
    getExaminePage() {
      const randomString = (e, t) => {
        // e选取字符长度; t字符串
        e = e || 4;
        const a = t.length;
        let n = '';
        for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
        return n;
      };
      function repeat(receiptNumber, random) {
        const randomStr = randomString(4, receiptNumber);
        if (!random.includes(randomStr)) {
          random.push(randomStr);
          return randomStr;
        } else {
          repeat(receiptNumber, random);
        }
      }
      function recurrence(table) {
        const randomArr = [];
        for (let i = 0; i < table.length; i++) {
          const randomId = repeat(table[i].receiptNumber, randomArr);
          table[i]['idCopy'] = table[i].id + randomId;
          if (table[i].siteBill && table[i].siteBill.length > 0) {
            recurrence(table[i].siteBill);
          }
        }
        return table;
      }

      const param = this.getQueryData();

      apiSiteReceiptGetPage(param).then(res => {
        if (res.code === 200) {
          res.data.records.map(item => {
            for (const key in item) {
              if (key === 'acceptTime' || key === 'auditTime') {
                if (item[key]) {
                  item[key] = item[key].replace('T', ' ');
                }
              }
            }
          });
          this.tableData = recurrence(res.data.records).map(item => {
            const { acceptUserId, createUser, auditUserId, receiptStatus } = item;
            return {
              ...item,
              siteName: '', // 主收款单网点名称不显示
              acceptUserName: this.createUser[acceptUserId] || '', // 核收人
              createUserName: this.createUser[createUser] || '', // 生成人员
              auditUserName: this.createUser[auditUserId] || '', // 审核人员
              receiptStatusItem: STATUS_OPTIONS[receiptStatus] // 收款状态
            };
          });
          this.total = res.data.total;
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 列表数据勾选
    handleSelectionChange(arr) {
      if (this.rowSelectFlag) return;
      this.selectData = arr;
    },
    // 获取对账批次详情
    showBillBatchNumber(data) {
      this.batchNumber = data.receiptNumber;
      this.billBatchData = data;
      this.showDetail = true;
    },
    // 搜索
    searchResources() {
      this.queryForm.pageNumber = 1;
      this.getExaminePage();
    },
    // 重置
    onReset() {
      this.queryForm.params = {
        ...PARAM
      };
      this.$refs.inputTextareaRef.clear();

      this.searchResources();
    },
    // 操作
    operationBtn() {
      if (this.selectData.length === 0) {
        this.$message.warning(this.$t('receivablePayable.SelectAtLeastOnePieceOfData')); // 最少要选择一条数据
        return;
      }
      if (this.selectData.length > 200) {
        this.$message.warning(this.$t('receivablePayable.maxSelectionLimit')); // 只能选择200条数据
        return;
      }
      this.collectionKey = new Date().getTime();
      this.showCollection = true;
    },

    // 账单导出
    onExport() {
      const { params } = this.getQueryData();
      params.ids = this.selectData.map(item => {
        return item.id;
      });

      apiSiteReceiptExport(params).then(res => {
        goFinanceExportPage();
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
.batchNumber {
  color: #007efd;
  cursor: pointer;
}
</style>
<style>
.columnTree .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  border-color: #aaa;
}
.columnTree .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #aaa;
}
.remarkStyle p {
  padding: 0!important;
  margin: 0!important;
}
.pending .el-table tr.background {
  background-color: #FF0000!important;
  color: #FFF;
}
.pending .el-table tr.background:hover td {
  background-color: #FF0000!important;
  color: #FFF;
}
.selectInput .el-form-item__label .el-input__inner {
  border: 0;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
